<template>
    <div>
        <transition name="fade" appear>
            <div v-if="!loading && !capRunning" class="page welcome-page">
                <section class="py-6 py-md-12">
                    <v-container>
                        <div class="mx-auto text-center" style="max-width: 1100px;">
                            <div style="text-transform: uppercase;">
                                <h1 class="strong-text--text" style="font-size: 2rem;">Take the first step</h1>
                                <h1 class="font-weight-bold strong-text--text larger">
                                    To <span class="primary--text">Knowledge</span> with us
                                </h1>
                            </div>
                            <div slot="description" class="mt-4 mb-8 text--text" style="font-size: 15px">
                                <p>
                                    Fintech Group started its career in Online Educational Services at the first appearance of the Corona virus, through it most efficient instructors who able to deliver information with easiest way and achieve the highest grades for students.
                                </p>
                                <!-- <p v-if="pcOnly">
                                    Although all education platforms were not able to achieve full efficiency in distance study, Fintech teachers were able to prove the opposite of the idea with highest technology used in E-Learning it succeeded to change the view of studying online evidenced by their opinion and achieving highest grades.
                                </p> -->
                            </div>
                            <div>
                                <v-btn large depressed color="primary" class="font-weight-bold" :to="{name: 'register'}" :block="phoneOnly">
                                    <v-icon class="me-2">mdi-account-plus</v-icon>
                                    <span>Get Started Now!</span>
                                </v-btn>
                                <v-btn large depressed color="primary" outlined class="font-weight-bold ms-md-3 mt-3 mt-md-0" :to="{name: 'courses'}" :block="phoneOnly">
                                    <v-icon class="me-2">mdi-play-box-multiple</v-icon>
                                    <span>our courses</span>
                                </v-btn>
                            </div>
                        </div>
                    </v-container>
                    
                </section>

                <section v-if="featuredCourses && featuredCourses.length" :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container :class="{'px-0': phoneOnly}">
                        <div class="d-md-flex justify-space-between align-center mb-8 mb-lg-15">
                            <h1 class="strong-text--text">
                                <v-icon :size="pcOnly ? 52 : 40" color="strong-text">mdi-play-box-multiple-outline</v-icon>
                                COURSES
                            </h1>
                            <template v-if="pcOnly">
                                <div class="flex-grow-1 mx-12">
                                    <v-divider></v-divider>
                                </div>
                                <div>
                                    <v-btn outlined color="primary" :to="{name: 'courses'}">
                                        <span>All Courses</span>
                                        <v-icon right>mdi-arrow-right</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </div>
                        <div v-if="pcOnly">
                            <v-row>
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in featuredCourses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                        </div>
                        <v-list v-else two-line class="px-0">
                            <course-list-item v-for="(course, i) in featuredCourses" class="px-7 px-lg-4" :key="course.id + '-' + i" :course="course" />

                            <div class="my-4 mx-6">
                                <v-btn block outlined color="primary" :to="{name: 'courses'}">
                                    <span>الانتقال إلى الدورات</span>
                                    <v-icon right>mdi-arrow-right</v-icon>
                                </v-btn>
                            </div>
                        </v-list>
                    </v-container>
                </section>

                <slot name="footer" />
            </div>
        </transition>


        <app-welcome-dialog v-if="platform == 'ios'" v-model="appWelcomeDialog" />
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AppWelcomeDialog from '@/components/default/dialogs/app-welcome'
import ESection from '@/components/default/layouts/e-section'

import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Welcome",
    data(){
        return {
            loading: false,
        }
    },
    components: {
        ESection,
        CourseCard,
        CourseListItem,
        AppWelcomeDialog
    },
    computed: {
        ...GlobalComputed,
        welcomeData(){
            return this.$store.state.globalModule.welcomeData;
        },
        featuredCourses(){
            return this.welcomeData.featured_courses;
        }
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadWelcomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    // this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    created(){
        if (this.capRunning){
            if (this.platform === 'ios'){
                this.appWelcomeDialog = true;
            }else{
                this.$router.push({name: 'login'});
            }
        }else{
            if (!this.featuredCourses || this.featuredCourses.length === 0){
                this.loadData();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
section{
    h1{
        font-size: 3rem!important;
        line-height: 1.3;
        font-weight: 500;

        &.larger{
            font-size: 4rem!important;
        }

        @media(max-width: 960px){
            font-size: 1.9rem!important;
            text-align: center;

            &.larger{
                font-size: 2.5rem!important;
            }
        }
    }
}
</style>